<template>
  <div class="page flex-col">
    <div class="scaler" style="margin-top: 40px; z-index: 1">
      <div class="subtitle-container">
        <div v-show="showSubtitle && currentSubtitle" class="subtitle-content">
          <span class="subtitle-text">{{ currentSubtitle }}</span>
      </div>
      </div>
      <div class="box_2 flex-col">
        <div class="group_1 flex-row justify-between">
          <img class="label_1" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG8c4490ef17ed7abdd3d6641305cdc290.png" />
          <span class="text_5" style="line-height: 42px">
            {{ String(leftMinutes).padStart(2, '0') + ':' + String(leftSeconds).padStart(2, '0') }}
          </span>
        </div>
        <div class="image-wrapper_1 flex-col"
          style="border: dashed 5px rgba(126, 180, 235, 1); border-radius: 20px; overflow: hidden"
          id="interview_ing_video">
<!--           <img class="image_1" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG86354fd4121a60c50dd81ab7a0e89a66.png" /> -->
          <img v-if="cameraAccess == 'denied' || closeVideoTransfer" class="image_1_" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG7299e06472f6ba6e89deac96771f2e41.png" />
          <span v-if="cameraAccess == 'denied' || closeVideoTransfer" class="text_2_">摄像头画面未授权</span>
          <VERTCVideo :whiteIntensity="setting.whiteIntensity" :smoothIntensity="setting.smoothIntensity"
            :sharpenIntensity="setting.sharpenIntensity" :filterIntensity="setting.filterIntensity"
            :filterType="setting.filterType" refName="interview_ing_video" :closeVideoTransfer="closeVideoTransfer"
            :closeAudioTransfer="closeAudioTransfer" ref="videoRef" @done="done()" @idle="playAnim('idle')"
            @talk="playAnim('talk')">
          </VERTCVideo>
        </div>
        <div class="group_2 flex-row justify-between">
          <div class="image-wrapper_2 flex-col" style="overflow: hidden; cursor: pointer" @click="
            pauseAudio()
            ">
            <img class="label_2" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGb7e2fa27b8735b359e21484f3a044e01.png" />
            <div v-if="closeAudioTransfer" class="not-allowed"></div>
          </div>
          <div class="image-wrapper_3 flex-col" style="overflow: hidden; cursor: pointer" @click="pauseRecording()">
            <img class="label_3" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG7c0648bd414304dfd5639d1220bf3c1d.png" />
            <div v-if="closeVideoTransfer" class="not-allowed"></div>
          </div>

        </div>
      </div>
      <div class="text-wrapper_2 flex-col">
        <span @click="overInterview()" class="text_4"
          style="line-height: 45px; cursor: pointer">结束面试</span>
      </div>
    </div>
    <!-- 添加AI音频流处理组件 -->
    <!--     <div class="audio-stream-container" v-if="showAudioProcessor">
      <AudioProcessor :interviewId="$store.state.interviewState.interviewId" />
      <el-button type="info" size="small" @click="toggleAudioProcessor" style="margin-top: 10px"> {{ showAudioProcessor ? '隐藏' : '显示' }}音频处理 </el-button>
    </div> -->
    <!-- 这里canvas的background可以用来为renderer的背景添加叠加色 -->
    <!-- <div style="position:absolute;width:100vw;height:100vh;background:black;" ref="canvas"></div> -->
    <!--     <div style="position: absolute; width: 100vw; height: 100vh; pointer-events: none">
      <img
        :src="anim.curAnim == 'idle' ? 'https://static.www.yuugeai.com/image/quiet_Scene1.c04f307c.gif' : 'https://static.www.yuugeai.com/image/speaking_Scene2.b3fa35cb.gif'"
        style="width: 1000px; height: 1414px; z-index: 1; position: absolute; margin-left: -5vw; margin-top: -10vh" />
      <img :src="setting.backgroundPath" style="width: 100%; height: 100%" />
    </div> -->
    <div style="position: absolute; width: 100vw; height: 100vh; pointer-events: none">
      <img v-show="anim.curAnim === 'idle'" src="https://static.www.yuugeai.com/image/quiet_Scene1.c04f307c.gif"
        class="anim-image anim-idle" />
      <img v-show="anim.curAnim !== 'idle'" src="https://static.www.yuugeai.com/image/speaking_Scene2.b3fa35cb.gif"
        class="anim-image anim-speaking" />
      <img :src="setting.backgroundPath" style="width: 100%; height: 100%" />
    </div>
    <!-- 自定义弹窗 -->
    <div v-show="waitForOverInterview" class="custom-popup">
      <div class="popup-content">
        <img src="./assets/img/interviewFinish.gif" alt="Loading" class="popup-image" />
        <div class="popup-text">
          面试官正在解析您的答案
          <br>请稍等片刻
        </div>
      </div>
    </div>

    <!-- 噪音检测弹窗 -->
    <div v-if="showNoiseDetection" class="custom-popup">
      <div class="popup-content noise-detection-popup">
        <div class="noise-detection-header">
          <div class="noise-title-spacer"></div>
          <h3 class="noise-title">正在进行噪音检测</h3>
          <button class="close-btn" @click="closeNoiseDetection">×</button>
        </div>
        
        <div class="noise-content">
          <div class="noise-image">
            <img src="./assets/img/check.png" alt="噪音检测" class="check-image" />
          </div>
          
          <div class="noise-info">
            <p class="noise-message">当前环境声源复杂,可能会对您面试的评分产生影响哦~换个安静些的环境吧</p>
            
            <div class="noise-level-indicator">
              <div class="progress-bar-container">
                <div class="progress-bar">
                  <div class="progress-fill" :style="{ width: (noiseLevel / 80 * 100) + '%' }"></div>
                  <div class="progress-marker" style="left: 81.25%"></div>
                  <div class="progress-current" :style="{ left: (noiseLevel / 80 * 100) + '%' }"></div>
                </div>
                <div class="progress-labels">
                  <span class="label-0">0dB</span>
                  <span class="label-50" style="position: absolute; left: 81.25%; transform: translateX(-50%);">65dB</span>
                  <span class="label-80">80dB</span>
                </div>
              </div>
              <div class="noise-labels">
                <span class="current-noise" :class="{ 'noise-high': noiseLevel > 65 }">
                  当前环境音: {{ noiseLevel }}dB
                </span>
                <span class="recommended-noise">推荐环境音: &lt;65dB</span>
              </div>
            </div>
            
            <div class="noise-actions">
              <button class="btn btn-outline" @click="startLater">稍后开始</button>
              <button class="btn btn-gradient" @click="startInterview" :disabled="noiseLevel > 65">
                开始面试
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 自定义 开始面试 确认弹窗 -->
    

    <!-- 自定义 不足3分钟 结束面试 确认弹窗 -->
    <div v-if="showShortEndConfirm" class="custom-popup">
      <div class="popup-content" style="max-width: 460px;">
        <img :src="tipImgUrl" alt="tip" class="popup-image" style="width: 140px;" />
        <div class="ui-title">确定要结束面试吗？</div>
        <div class="ui-desc">
          您的面试时间过短（<span class="ui-strong">小于一分钟</span>），我们无法对您进行全面的评估。因此将<span class="ui-strong">不会产生面试成绩</span>哦~
        </div>
        <div class="ui-actions">
          <button class="btn btn-outline" @click="handleShortEndConfirm">确定结束</button>
          <button class="btn btn-gradient" @click="handleShortEndCancel">继续面试</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VERTCVideo from '@/components/VERTCVideo/index.vue'
import RtcClient from '@/rtc/RtcClient.js'
import cameraManager from '@/utils/CameraManager.js'
import VERTC from '@volcengine/rtc'
import { getRtcToken } from '@/api/rtc.js'
import { tlv2String } from '@/utils/rtcUtil.js'
import { lxUploadFile, saveInterviewScreenshot } from '@/api/upload.js'
import QuietScene from './assets/img/quiet_Scene1.gif'
import SpeakingScene from './assets/img/speaking_Scene2.gif'
import { getRecommendVideo } from '@/api/recommend'
import { STAGE_PROMPTS, getPromptAtTime, getAllTimePoints } from '@/config/promptConfig.js'
import { getRandomMultiplePeopleMessage, LEAVE_SCREEN_MESSAGES, getRandomMessage } from '@/constants/behaviorMessages.js'
import { FilesetResolver, FaceLandmarker } from '@mediapipe/tasks-vision'
import { startMemberInterview } from '@/api/user'
export default {
  components: {
    VERTCVideo,
    // SideBar,
    // AudioProcessor,
  },
  created() {

    try {
      const raw = localStorage.getItem('jobInformation');
      if (raw) {
        const { position } = JSON.parse(raw) || {};

        this.position = position;

      }
    } catch (e) {
      // 数据损坏或格式错误时兜底
      console.warn('jobInformation 不存在', e);
    }



    /*     this.leftMinutes = this.$store.state.interviewState.interviewDuration
    
        this.leftSeconds = 0
        this.timer = setInterval(() => {
          // 计算总剩余秒数
          const totalSeconds = this.leftMinutes * 60 + this.leftSeconds
    
          // 当剩余时间等于30秒时触发提示
          if (totalSeconds === 30) {
            // 发送中优先级文本（等待当前语音播放完毕）
            this.handleThirtySecondsLeft()
    
          }
          if (this.leftSeconds > 0) this.leftSeconds--
          else if (this.leftMinutes > 0) {
            this.leftMinutes--
            this.leftSeconds = 59
          } else {
            clearInterval(this.timer)
            // 当时间结束时显示弹窗提示，然后结束面试
            this.$message.info({
              message: '因为时间的原因，我们的面试到此结束，感谢您参加此次面试',
              duration: 5000,
              onClose: () => {
                this.overInterview()
              }
            })
          }
        }, 1000) */
    const interviewState = this.$store.state.interviewState
    if (!interviewState.interviewStarted) this.$router.push('/store/dashboard/profile')
    const setting = {
      whiteIntensity: 0,
      smoothIntensity: 0,
      sharpenIntensity: 0,
      filterType: '不使用',
      filterIntensity: 0,
      backgroundPath: require('./assets/img/FigmaDDSSlicePNG89def777d99a3bb366c5d59c29791444_clip.png'),
    }
    for (const key in interviewState.usingBeautifys) {
      const beautify = interviewState.usingBeautifys[key]
      switch (beautify.name) {
        case '美白':
          setting.whiteIntensity = beautify.slideValue * 0.01
          break
        case '磨皮':
          setting.smoothIntensity = beautify.slideValue * 0.01
          break
        case '锐化':
          setting.sharpenIntensity = beautify.slideValue * 0.01
          break
      }
    }
    if (interviewState.usingFilter && interviewState.usingFilter.name != '不使用') {
      setting.filterType = interviewState.usingFilter.name
      setting.filterIntensity = interviewState.usingFilter.slideValue * 0.01
    }
    if (interviewState.usingBackground && interviewState.usingBackground.name != '不使用') {
      setting.backgroundPath = interviewState.usingBackground.img
    }
    this.setting = setting
  },

  async mounted() {

    this.startNoiseDetection()
    this.$message.success('请打开面试录制，我们会根据录制视频为您的面试表现评分。')
    const permissionStatus = await navigator.permissions.query({ name: 'camera' })
    this.permissionStatus = permissionStatus
    this.cameraAccess = permissionStatus.state
    permissionStatus.onchange = () => {
      this.cameraAccess = permissionStatus.state
    }


    await this.initializeRtc()
    this.showNoiseDetection = true
    
    // 提取岗位JD和候选人背景总结（只提取一次）
    this.extractPromptSections()
    
    // 预加载行为检测资源（静默加载，不影响页面正常运行）
    this.preloadBehaviorDetectionResources()
    
  },
  data() {
    return {
      isFinalQuestionAsked: false,
      microphone: null,
      timer: null,
      speaking: false,
      waitForOverInterview: false,
      closeVideoTransfer: true,
      closeAudioTransfer: true,
      cameraAccess: 'denied',
      leftMinutes: 0,
      leftSeconds: 0,
      setting: null,
      isInterviewStartedTracked: false, // 是否已上报面试开始埋点
      answerSubmitCount: 0, // 答题提交次数
      scene: null,
      renderer: null,
      loader: null,
      camera: null,
      controls: null,
      mixers: [],
      blobUrl: '',
      showAudioProcessor: false,
      anim: {
        curAnim: 'idle',
        idleUrl: require('./assets/img/quiet_Scene2.gif'),
        talkUrl: require('./assets/img/speaking_Scene2.gif'),
      },
      isRtcInitialized: false,
      isRtcConnected: false,
      isAiSpeaking: false,
      isAiCurrentlySpeaking: false,
      isUserSpeaking: false,  // 用户是否在说话
      lastUserMessageTime: null,  // 用户最后一条消息的时间
      userSilenceTimer: null,  // 用户停顿检测定时器
      aiSpeechFinishResolvers: [],  // AI说完的Promise resolver队列
      lastAiDefiniteMessageTime: null,  // 最后一条definite: true消息的时间
      lastAiDefiniteTime: null,  // AI最后一条definite消息的时间（保留用于兼容）
      rtcStatusMessage: '等待初始化...',
      rtcEventListeners: null,  // RTC 事件监听器引用，用于清理
      permissionStatus: null,  // 权限状态对象，用于清理 onchange
      screenshotRetryTimeoutId: null,  // 截图重试定时器 ID
      userId: '',
      roomId: '',
      appId: '67adf9d0d35c9e01792239ae',
      token: '',
      botName: 'RobotMan_',
      welcomeMessage: '你好，我是你的AI面试官 Cathy，请问准备好开始面试了吗？',
      msgHis: [],
      msgHisIndex: 0,
      QuietScene,
      SpeakingScene,
      position: '',
      showSubtitle: true,
      currentSubtitle: '',
      subtitleSequence: 0,
      subtitleClearTimer: null,
      subtitleUpdateTimer: null, // 字幕更新防抖定时器
      animDebounceTimer: null, // 动画防抖定时器
      lastAnimSwitchTime: 0, // 最后一次动画切换时间
      lastStreamStatsCheck: 0, // 上次音频流统计检查时间
      startTimestamp: null, // 面试开始时间
      jdSection: '', // 岗位JD总结（在 mounted 时提取）
      backgroundSection: '', // 候选人背景总结（在 mounted 时提取）
      isShortInterview: false, // 是否为不足5分钟的面试
      showShortEndConfirm: false,
      prevAudioClosed: true,
      prevVideoClosed: true,
      tipImgUrl: require('./assets/img/tips.png'),
      showNoiseDetection: false,
      noiseLevel: 0,
      noiseDetectionInterval: null,
      audioContext: null,
      analyser: null,
      dataArray: null,
      noiseLevelHistory: [],
      maxHistorySize: 10,
      currentStream: null,
      screenshotTimer: null,
      screenshotCount: 0,
      maxScreenshots: 4,
      screenshotUrls: [],
      // 结束提示相关（用于防止重复结束）
      hasInterviewEndMessageShown: false, // 防止结束提示/结束逻辑重复触发
      autoEndOnCurrentLast30AiTurn: false, // 是否把当前这轮“最后30秒内开始的 AI 发言”视为最后一句，结束后立刻收尾
      userSpokeInLast30Seconds: false, // 在倒计时最后30秒内，用户是否有说过话（用于判断“最后一句”归属）
      interviewStartTime: null,
      // 阶段性 Prompt 相关
      executedPromptTimes: new Set(),  // 已执行的时间点（避免重复）
      stagePromptTimePoints: [],       // 所有配置的时间点
      // 行为检测相关
      faceLandmarker: null,
      detectionVideo: null,
      detectionInterval: 1000,
      detectionTimeoutId: null,
      currentConfirmedStatus: null,
      lastLeaveWarnStatus: null,
      lastMultipleWarnStatus: null,
      detectionErrorCount: 0,
      detectionDisabled: false,
      errorRetryDelay: 2000,
      behaviorDetectionInitialized: false, // 标记行为检测是否已初始化
      behaviorDetectionResourcesLoaded: false, // 标记行为检测资源是否已预加载
      aiSpeechCount: 0, // AI说完话的次数计数
      lastReportedCount: -1, // 最后报告的数量
      isUserGone: false // 用户是否离开画面
    }
  },
  methods: {
    // 清空所有字幕状态
    clearSubtitleState() {
      this.currentSubtitle = '';
      this.subtitleSequence = 0;
      if (this.subtitleUpdateTimer) {
        clearTimeout(this.subtitleUpdateTimer);
        this.subtitleUpdateTimer = null;
      }
      if (this.subtitleClearTimer) {
        clearTimeout(this.subtitleClearTimer);
        this.subtitleClearTimer = null;
      }
    },
    startInterviewTimer() {
      this.leftMinutes = this.$store.state.interviewState.interviewDuration;
      this.leftSeconds = 0;
      this.timer = setInterval(() => {
        const totalSeconds = this.leftMinutes * 60 + this.leftSeconds;

        // 计算经过时间并检查阶段性 Prompt
        const elapsedSeconds = this.startTimestamp
          ? Math.floor((Date.now() - this.startTimestamp) / 1000)
          : 0;
        this.checkAndInsertStagePrompt(elapsedSeconds);

        if (totalSeconds === 30 && !this.isFinalQuestionAsked) {
          this.handleThirtySecondsLeft();
        }
        if (this.leftSeconds > 0) {
          this.leftSeconds--;
        } else if (this.leftMinutes > 0) {
          this.leftMinutes--;
          this.leftSeconds = 59;
        } else {
          clearInterval(this.timer);
          // 倒计时结束，根据情况处理
          this.handleTimerEnded();
        }
      }, 1000);
    },
    async pauseAudio() {
      this.closeAudioTransfer = !this.closeAudioTransfer
      if (this.closeAudioTransfer) {
        await RtcClient.stopAudioCapture()
      } else {
        await RtcClient.startAudioCapture(this.microphone)
      }

    },
    async startNoiseDetection() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.currentStream = stream
        
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
        this.analyser = this.audioContext.createAnalyser()
        this.microphone = this.audioContext.createMediaStreamSource(stream)
        
        this.analyser.fftSize = 512
        this.analyser.smoothingTimeConstant = 0.85
        this.microphone.connect(this.analyser)
        
        const bufferLength = this.analyser.frequencyBinCount
        this.dataArray = new Uint8Array(bufferLength)
        
        this.noiseLevelHistory = []
        
        this.startRealTimeAnalysis()
        
        this.$message.success('开始噪音检测，请保持安静')
      } catch (error) {
        console.error('无法访问麦克风:', error)
        this.$message.error('无法访问麦克风，请检查权限设置')
        this.startSimulatedNoiseDetection()
      }
    },
    startRealTimeAnalysis() {
      this.noiseDetectionInterval = setInterval(() => {
        if (this.analyser && this.dataArray) {
          this.analyser.getByteFrequencyData(this.dataArray)
          
          let sumSquares = 0
          let validSamples = 0
          for (let i = 0; i < this.dataArray.length; i++) {
            const value = this.dataArray[i]
            if (value > 0) {
              sumSquares += value * value
              validSamples++
            }
          }
          
          if (validSamples === 0) {
            return
          }
          
          const rms = Math.sqrt(sumSquares / validSamples)
          
          const normalized = rms / 255
          let dbLevel = 0
          
          if (normalized > 0.001) {
            dbLevel = 20 * Math.log10(normalized * 50) + 30
            dbLevel = Math.max(30, Math.min(80, dbLevel))
          } else {
            dbLevel = 30
          }
          
          this.noiseLevelHistory.push(dbLevel)
          
          if (this.noiseLevelHistory.length > this.maxHistorySize) {
            this.noiseLevelHistory.shift()
          }
          
          const historyLength = this.noiseLevelHistory.length
          if (historyLength > 0) {
            const sum = this.noiseLevelHistory.reduce((a, b) => a + b, 0)
            const smoothedLevel = sum / historyLength
            
            const alpha = historyLength < 5 ? 0.5 : 0.3
            const previousLevel = this.noiseLevel || smoothedLevel
            const finalLevel = alpha * smoothedLevel + (1 - alpha) * previousLevel
            
            this.noiseLevel = Math.round(finalLevel)
          }
        }
      }, 300)
    },

    startSimulatedNoiseDetection() {
      this.noiseLevel = 40
      
      this.noiseDetectionInterval = setInterval(() => {
        const baseLevel = 40
        const variation = (Math.random() - 0.5) * 8
        this.noiseLevel = Math.max(30, Math.min(60, baseLevel + variation))
      }, 2000)
    },

    stopNoiseDetection() {
      if (this.noiseDetectionInterval) {
        clearInterval(this.noiseDetectionInterval)
        this.noiseDetectionInterval = null
      }
      
      if (this.currentStream) {
        this.currentStream.getTracks().forEach(track => {
          track.stop()
        })
        this.currentStream = null
      }
      
      if (this.microphone && typeof this.microphone.disconnect === 'function') {
        this.microphone.disconnect()
        this.microphone = null
      } else if (this.microphone) {
        // 如果 microphone 不是 MediaStreamAudioSourceNode，直接设置为 null
        this.microphone = null
      }
      
      if (this.analyser) {
        this.analyser.disconnect()
        this.analyser = null
      }
      
      if (this.audioContext && this.audioContext.state !== 'closed') {
        this.audioContext.close().catch(err => {
          console.warn('关闭音频上下文失败:', err)
        })
        this.audioContext = null
      }
      
      this.dataArray = null
      this.noiseLevelHistory = []
    },

    closeNoiseDetection() {
      this.showNoiseDetection = false
      this.stopNoiseDetection()
    },

    startLater() {
      this.closeNoiseDetection()
      this.$router.push('/')
    },

    async startInterview() {
      if (this.noiseLevel > 65) {
        this.$message.warning('环境噪音过高，请选择安静的环境后再开始面试')
        return
      }
      try {
        const currentJob = this.$store.state.interviewState.currentInterviewJob
        const jobId = currentJob?.id || currentJob?.job_id || null
        
        const res = await startMemberInterview(jobId)
        const canStart = res?.data?.code === 1 && (res?.data?.data === true || res?.data?.data === 1)
        if (!canStart) {
          this.$message.warning('无法开始面试，请稍后重试')
          return
        }
      } catch (e) {
        this.$message.error('调用开始面试接口失败，请稍后重试')
        return
      }
      
      // 兜底检查：如果 RTC 未初始化，等待初始化完成（最多等待 10 秒）
      if (!this.isRtcInitialized) {
        const maxWaitTime = 10000 // 10 秒
        const checkInterval = 100 // 每 100ms 检查一次
        const startWaitTime = Date.now()
        
        while (!this.isRtcInitialized && (Date.now() - startWaitTime) < maxWaitTime) {
          await new Promise(resolve => setTimeout(resolve, checkInterval))
        }
        
        if (!this.isRtcInitialized) {
          console.error('[面试启动] 等待超时，RTC 仍未初始化')
          this.$message.error('由于网络原因，RTC 初始化超时，请刷新页面重试')
          return
        }
        
      }
      this.closeNoiseDetection()
      this.closeAudioTransfer = false
      this.closeVideoTransfer = false
      await this.$refs.videoRef.startRecording()
      await this.connectAndStartAi()
      this.startTimestamp = Date.now()
      this.interviewStartTime = Date.now()

      // 初始化阶段性 Prompt
      this.executedPromptTimes.clear()
      this.stagePromptTimePoints = getAllTimePoints()

      this.startInterviewTimer();
      this.startScreenshotTimer();
      // 开始面试后调用推荐视频获取
      this.fetchRecommendVideos();
    },

    showStartInterviewConfirm() {
      this.$confirm('是否开始面试？（请注意保持环境安静，防止干扰面试过程）', '提示', {
        confirmButtonText: '开始面试',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(async () => {
          this.closeAudioTransfer = false
          this.closeVideoTransfer = false
          await this.$refs.videoRef.startRecording()
          await this.connectAndStartAi()
          this.startTimestamp = Date.now()
          this.startInterviewTimer();
        })
        .catch(() => {
          // 取消时保持关闭状态
        })
    },
    pauseRecording() {
      this.closeVideoTransfer = !this.closeVideoTransfer
      if (this.closeVideoTransfer) {
        this.$refs.videoRef.pauseRecording()
      } else {
        this.$refs.videoRef.resumeRecording()
      }


    },

    /**
     * 从 basePrompt 中提取指定标题的段落
     * @param {string} basePrompt - 基础 prompt 文本
     * @param {string} titleKey - 标题键名 ('jd' 或 'background')
     * @returns {string} 提取的段落内容
     */
    extractPromptSection(basePrompt, titleKey) {
      const TAG_MAP = {
        jd: { openTag: '<JD>', closeTag: '</JD>' },
        background: { openTag: '<RESUME>', closeTag: '</RESUME>' }
      }

      const tags = TAG_MAP[titleKey]
      if (!tags) return ''

      // 查找开始标签
      const openTagIndex = basePrompt.indexOf(tags.openTag)
      if (openTagIndex === -1) return ''

      // 查找结束标签
      const closeTagIndex = basePrompt.indexOf(tags.closeTag, openTagIndex + tags.openTag.length)
      if (closeTagIndex === -1) return ''

      // 提取标签之间的内容
      const start = openTagIndex + tags.openTag.length
      const end = closeTagIndex
      return basePrompt.substring(start, end).trim()
    },
    /**
     * 提取岗位JD和候选人背景总结（在组件初始化时调用一次）
     */
    extractPromptSections() {
      const fullPrompt = this.prompt || ''
      
      this.jdSection = this.extractPromptSection(fullPrompt, 'jd')
      this.backgroundSection = this.extractPromptSection(fullPrompt, 'background')
    },
    /**
     * 检查并插入阶段性 Prompt
     * @param {number} elapsedSeconds - 从面试开始经过的秒数
     */
    async checkAndInsertStagePrompt(elapsedSeconds) {
      // 检查当前时间点是否有配置的 Prompt
      const promptMsg = getPromptAtTime(elapsedSeconds);

      if (!promptMsg) {
        return; // 当前时间点没有配置 Prompt
      }

      // 检查是否已经执行过（避免重复）
      if (this.executedPromptTimes.has(elapsedSeconds)) {
        return;
      }

      // 标记为已执行
      this.executedPromptTimes.add(elapsedSeconds);

      try {

        // 找到当前时间点对应的是第几个阶段（基于 STAGE_PROMPTS 的顺序）
        const stageIndex = STAGE_PROMPTS
          ? STAGE_PROMPTS.findIndex(item => item.second === elapsedSeconds)
          : -1

        const stagesWithJDOnly = [0, 1, 3] // 只放岗位JD的阶段
        const stagesWithBackgroundOnly = [] // 只放候选人背景总结的阶段（目前没有）
        const stagesWithBoth = [2, 4] // 两个都放的阶段

        // 根据阶段索引判断如何拼接（直接使用 computed 属性）
        let combinedPrompt = promptMsg
        if (stagesWithJDOnly.includes(stageIndex)) {
          combinedPrompt = [promptMsg, this.jdSection].filter(Boolean).join('\n\n')
        } else if (stagesWithBackgroundOnly.includes(stageIndex)) {
          combinedPrompt = [promptMsg, this.backgroundSection].filter(Boolean).join('\n\n')
        } else if (stagesWithBoth.includes(stageIndex)) {
          combinedPrompt = [promptMsg, this.jdSection, this.backgroundSection].filter(Boolean).join('\n\n')
        }

        await RtcClient.insertStagePrompt(
          this.roomId,
          this.userId,
          combinedPrompt
        );

      } catch (error) {
        console.error(`[阶段性 Prompt] 插入失败 (${elapsedSeconds}秒):`, error);
        // 不阻塞面试流程，仅记录错误
      }
    },

    async overInterview() {
      const now = Date.now()
      const elapsedSeconds = this.startTimestamp ? Math.floor((now - this.startTimestamp) / 1000) : null
      
      // 计算实际面试时长（分钟）并保存到store
      if (elapsedSeconds !== null) {
        const actualDurationMinutes = Math.round(elapsedSeconds / 60 * 10) / 10 // 保留一位小数
        this.$store.dispatch('interviewState/setActualInterviewDuration', actualDurationMinutes)
      }

      // 埋点：AI面试结束
      if (this.isInterviewStartedTracked && this.$tracking) {
        const interviewId = this.$store.state.interviewState.interviewId
        const totalDuration = elapsedSeconds ? elapsedSeconds * 1000 : 0 // 转换为毫秒
        const totalQuestions = Math.max(this.answerSubmitCount, 1) // 至少1题
        const completeRate = this.answerSubmitCount > 0 ? this.answerSubmitCount / totalQuestions : 0
        
        // 判断结束类型
        let finishType = 'normal'
        if (elapsedSeconds !== null && elapsedSeconds < 60) {
          finishType = 'user_quit' // 短时退出视为用户中途退出
        } else if (this.leftMinutes === 0 && this.leftSeconds === 0) {
          finishType = 'timeout' // 倒计时结束视为超时
        }
        
        if (interviewId) {
          this.$tracking.trackAiInterviewFinish({
            interviewId: interviewId,
            finishType: finishType,
            totalDuration: totalDuration,
            completeRate: completeRate
          })
        }
      }

      const proceedToEnd = async () => {
        this.closeVideoTransfer = true
        this.closeAudioTransfer = true
        this.waitForOverInterview = true
        clearInterval(this.timer)  // 清除计时器
        this.executedPromptTimes.clear()  // 清理阶段性 Prompt 记录
        this.stopScreenshotTimer() // 停止定时拍照
        try {
          this.stopBehaviorDetection()
        } catch (error) {
          console.warn('[面试结束] 停止行为检测时发生错误，但不影响后续流程:', error)
        }
        this.disconnectAndStopAi()

        this.msgHis?.forEach(dialogue => {
          this.$store.commit('interviewState/SET_DIALOGUES', dialogue)
        })

        this.$store.dispatch('interviewState/formatDialogues')

        this.$refs.videoRef.stopVideoRecorder(this.isShortInterview)

        // 保存面试截图
        await this.saveScreenshots()

        // 强制关闭所有媒体设备，彻底释放摄像头/麦克风
        await this.forceCloseAllMediaStreams()
      }

      if (elapsedSeconds !== null && elapsedSeconds < 180) {
        this.prevAudioClosed = this.closeAudioTransfer
        this.prevVideoClosed = this.closeVideoTransfer
        this.closeAudioTransfer = true
        this.closeVideoTransfer = true
        try { await RtcClient.stopAudioCapture() } catch (e) { }
        try { if (this.$refs.videoRef && this.$refs.videoRef.pauseRecording) this.$refs.videoRef.pauseRecording() } catch (e) { }
        this.showShortEndConfirm = true
      } else {
        proceedToEnd()
      }
    },
    handleShortEndCancel() {
      this.showShortEndConfirm = false
      this.closeAudioTransfer = this.prevAudioClosed
      this.closeVideoTransfer = this.prevVideoClosed
      if (!this.prevAudioClosed) {
        try { RtcClient.startAudioCapture(this.microphone) } catch (e) { }
      }
      if (!this.prevVideoClosed) {
        try { if (this.$refs.videoRef && this.$refs.videoRef.resumeRecording) this.$refs.videoRef.resumeRecording() } catch (e) { }
      }
    },
    async handleShortEndConfirm() {
      this.showShortEndConfirm = false
      this.isShortInterview = true
      this.closeVideoTransfer = true
      this.closeAudioTransfer = true
      this.waitForOverInterview = true
      clearInterval(this.timer)
      
      const now = Date.now()
      const elapsedSeconds = this.startTimestamp ? Math.floor((now - this.startTimestamp) / 1000) : null
      
      // 埋点：AI面试结束（短时面试）
      if (this.isInterviewStartedTracked && this.$tracking) {
        const interviewId = this.$store.state.interviewState.interviewId
        const totalDuration = elapsedSeconds ? elapsedSeconds * 1000 : 0
        const totalQuestions = Math.max(this.answerSubmitCount, 1)
        const completeRate = this.answerSubmitCount > 0 ? this.answerSubmitCount / totalQuestions : 0
        
        if (interviewId) {
          this.$tracking.trackAiInterviewFinish({
            interviewId: interviewId,
            finishType: 'user_quit',
            totalDuration: totalDuration,
            completeRate: completeRate
          })
        }
      }
      
      try {
        this.stopBehaviorDetection()
      } catch (error) {
        console.warn('[短时面试结束] 停止行为检测时发生错误，但不影响后续流程:', error)
      }
      
      // 确保断开 AI 连接完成后再继续
      await this.disconnectAndStopAi()
      
      this.msgHis?.forEach(dialogue => {
        this.$store.commit('interviewState/SET_DIALOGUES', dialogue)
      })
      this.$store.dispatch('interviewState/formatDialogues')
      
      // 停止视频录制
      if (this.$refs.videoRef && this.$refs.videoRef.stopVideoRecorder) {
        await this.$refs.videoRef.stopVideoRecorder(this.isShortInterview)
      }
      // 保存面试截图
      await this.saveScreenshots()
      await this.forceCloseAllMediaStreams()
      
      // 等待足够的时间确保摄像头资源完全释放
      await new Promise(resolve => setTimeout(resolve, 1500))
      
      // 触发视频推荐获取
      this.fetchRecommendVideos()
      this.waitForOverInterview = false
      
      // 跳转到面试解析页面
      // this.$router.push({ path: '/store/Interview_Analysis', query: { feedback: '1', short: '1' } })
      //跳转到面试记录
      this.$router.push({path:'/store/dashboard/profile'})
    },
    // 彻底关闭摄像头/麦克风与所有媒体资源
    async forceCloseAllMediaStreams() {
      try {
        // 先让子组件释放自身资源（录屏流、FFmpeg、扩展等）
        if (this.$refs && this.$refs.videoRef && this.$refs.videoRef.releaseResources) {
          await this.$refs.videoRef.releaseResources()
        }
      } catch (e) {
        console.error('释放子组件媒体资源失败:', e)
      }

      try {
        await RtcClient.stopAudioCapture()
      } catch (e) {
        console.warn('停止音频采集时出现问题:', e)
      }

      try {
        await RtcClient.leaveRoom()
      } catch (e) {
        console.warn('离开房间时出现问题:', e)
      }

      try {
        if (RtcClient.destroyEngine) {
          await RtcClient.destroyEngine()
        }
      } catch (e) {
        console.warn('销毁 RTC 引擎时出现问题:', e)
      }

      try {
        // 停止所有 video/audio 元素绑定的媒体流，并清空 srcObject
        cameraManager.stopAllMediaElements()
        // 停止 CameraManager 已记录的所有流
        cameraManager.stopAllStreams()
      } catch (e) {
        console.warn('强制关闭本地设备时出现问题:', e)
      }
    },
    done() {
      // 获取所需数据
      const score = this.$store.state.interviewState.interviewScore
      const interviewId = this.$store.state.interviewState.interviewId
      const duration = this.$store.state.interviewState.actualInterviewDuration || this.$store.state.interviewState.interviewDuration

      const dialogues = JSON.stringify(this.$store.state.interviewState.dialogues);


      // const interviewData = {
      //   answer_content_desc: dialogues,
      //   answer_content_score: this.$store.state.interviewState.content,
      //   body_language_desc: "站起，保持 fermi  fermi  fermi",
      //   body_language_score: this.$store.state.interviewState.body_language,
      //   facial_expression_desc: "站起，保持 fermi  fermi  fermi",
      //   facial_expression_score: this.$store.state.interviewState.facial_expression,
      //   grooming_desc: "站起，保持 fermi  fermi  fermi",
      //   grooming_score: this.$store.state.interviewState.grooming,
      //   interview_id: interviewId,
      //   overall_score: Math.round((this.$store.state.interviewState.interviewScore && this.$store.state.interviewState.interviewScore.totalScore) || 0),
      //   interview_time: `${duration}分钟`,
      //   interview_tone_desc: "站起，保持 fermi  fermi  fermi",
      //   interview_tone_score: this.$store.state.interviewState.interview_tone,
      //   jd_url: this.$store.state.interviewState.jd?.url || "",
      //   resume_url: this.$store.state.interviewState.cv?.url || "",
      //   timely_response_desc: "站起，保持 fermi  fermi  fermi",
      //   timely_response_score: this.$store.state.interviewState.timely_response,
      //   video_path: "",
      //   interview_position: this.position || '未命名面试',
      // }

      // 从 localStorage 读取面试来源信息
      // 如果是从 hot-jobs 或 hot-companies 进入的，interview_source 为 1，否则为 0
      let interviewSource = 0
      try {
        const storedSource = localStorage.getItem('interviewSource')
        if (storedSource) {
          const parsed = JSON.parse(storedSource)
          if (parsed && parsed.interview_source === 1) {
            interviewSource = 1
          }
          // 读取后立即清除，避免状态残留影响下次判断
          localStorage.removeItem('interviewSource')
        }
      } catch (e) {
        console.warn('读取 interviewSource 失败:', e)
        localStorage.removeItem('interviewSource')
      }

      const interviewData = {
        answer_content_desc: dialogues,
        interview_position: this.position || '未知岗位',
        interview_time: `${duration}分钟`,
        resume_url: this.$store.state.interviewState.cv?.url || "",
        jd_url: this.$store.state.interviewState.jd?.url || "",
        interview_id: interviewId,
        interview_source: interviewSource,
      }


      // 不足5分钟则不保存成绩，直接跳转面试解析并打开反馈
      // 注意：不足5分钟的面试已经在 handleShortEndConfirm 中处理了跳转，这里不需要重复处理
      if (this.isShortInterview) {
        return
      }

      // 调用API保存面试记录
      this.$message.info('正在保存面试记录...')

      // 导入API函数
      const { addUserInterview } = require('@/api/mianshilishi.js')

      //调用
      addUserInterview(interviewData).then(response => {

        if (response.data && response.data.code === 0) {
          this.$message.success('面试记录保存成功')
        } else {
          this.$message.warning('面试记录保存提示：' + (response.data.msg || '未知状态'))
        }
      }).catch(error => {
        console.error('保存面试记录失败详情：', error)
        this.$message.error('面试记录保存失败，请稍后重试')
      }).finally(() => {
        this.$message.success('最终得分：' + Math.round((this.$store.state.interviewState.interviewScore && this.$store.state.interviewState.interviewScore.totalScore) || 0))
        this.waitForOverInterview = false
        // 触发视频推荐获取
        this.fetchRecommendVideos()
        setTimeout(() => {
          this.$router.push('/store/Interview_Analysis')
        }, 3000)

      })

    },
    async fetchRecommendVideos() {
      try {
        const cv = this.$store.state.interviewState.cv
        const jd = this.$store.state.interviewState.jd
        const resume_url = cv && cv.url ? cv.url : localStorage.getItem('cv_url')
        const jd_url = jd && jd.url ? jd.url : localStorage.getItem('jd_url')
        if (!resume_url || !jd_url) return
        const { data } = await getRecommendVideo({ resume_url, jd_url })
        if (data && data.code === 1 && Array.isArray(data.data)) {
          this.$store.commit('interviewState/SET_RECOMMEND_VIDEOS', data.data)
        }
      } catch (e) {
        console.error('拉取视频推荐失败:', e)
      }
    },
    playPreheater() {
      // this.$refs.videoRef.playPreheater()
    },
    toggleAudioProcessor() {
      this.showAudioProcessor = !this.showAudioProcessor
    },
    playAnim(animName) {
      // 防抖机制：避免频繁切换动画
      if (this.anim.curAnim === animName) {
        return
      }

      // 清除之前的防抖定时器
      if (this.animDebounceTimer) {
        clearTimeout(this.animDebounceTimer)
      }

      // 设置防抖延迟
      this.animDebounceTimer = setTimeout(() => {
        this.anim.curAnim = animName
        this.lastAnimSwitchTime = Date.now()
      }, 100) // 100ms防抖延迟
    },
    forceSetAnimState(animName, source = 'unknown') {
      // 清除防抖定时器
      if (this.animDebounceTimer) {
        clearTimeout(this.animDebounceTimer)
      }

      this.anim.curAnim = animName
      this.lastAnimSwitchTime = Date.now()
    },
    async initializeRtc() {
      if (this.isRtcInitialized) return
      try {
        this.rtcStatusMessage = 'RTC 初始化中...'

        // load rtc token
        const rtcToken = await getRtcToken()
        this.token = rtcToken.data.data.token
        this.roomId = String(rtcToken.data.data.roomId)

        // load user id from local storage
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
          this.userId = String(JSON.parse(userInfo).id)
        }

        // Hardcoded values
        const appId = this.appId
        const userId = this.userId // User's fixed ID
        const roomId = this.roomId // Fixed room ID

        RtcClient.createEngine({ userId, roomId, appId })

        this.rtcEventListeners = {
          [VERTC.events.onUserJoined]: (e) => {
            this.rtcStatusMessage = `用户 ${e.userName || e.userId} 已加入`
          },

          [VERTC.events.onUserLeave]: (e) => {
            this.rtcStatusMessage = `用户 ${e.userName || e.userId} 已离开`
            if (e.userId !== userId) {
              this.isAiSpeaking = false
              this.playAnim('idle')
            }
          },
          [VERTC.events.onUserPublishStream]: (e) => {
            const aiUserIdPrefix = 'RobotMan_'
            if (e.isAudio && e.userId.startsWith(aiUserIdPrefix)) {
              // 不在这里直接设置动画状态，等待实际音频数据
              this.rtcStatusMessage = 'AI 音频流已发布'
            }
          },
          [VERTC.events.onUserUnpublishStream]: (e) => {
            const aiUserIdPrefix = 'RobotMan_'
            if (e.isAudio && e.userId.startsWith(aiUserIdPrefix)) {
             // 音频流停止时立即切换到idle状态
             this.isAiSpeaking = false
              this.isAiCurrentlySpeaking = false
              this.rtcStatusMessage = 'AI 音频流已停止'
              this.playAnim('idle')
            }
          },

                              // 远端 AI 说话判断 - 基于音频流统计数据的精确检测
          [VERTC.events.onRemoteStreamStats]: (e) => {
            // 检查是否是AI用户的音频流
            const aiUserIdPrefix = 'RobotMan_'
            if (e.userId && e.userId.startsWith(aiUserIdPrefix) && e.audioStats) {
              // 节流：限制检查频率，每200ms最多检查一次
              const now = Date.now()
              if (now - this.lastStreamStatsCheck < 200) {
                return
              }
              this.lastStreamStatsCheck = now
              
              const audioBitrate = e.audioStats.receivedKBitrate || 0
              const audioLevel = e.audioStats.audioLevel || 0
              
              // 使用更精确的阈值判断AI是否在说话
              const isSpeaking = audioBitrate > 20 && audioLevel > 0.01
              
              // 检查最近是否有消息处理控制的动画切换
              const timeSinceLastSwitch = Date.now() - this.lastAnimSwitchTime
              const isRecentMessageControl = timeSinceLastSwitch < 2000 // 2秒内的消息控制
              
              // 只有当状态真正改变时才更新动画，并且优先级低于消息处理
              if (isSpeaking && !this.isAiSpeaking && !this.isAiCurrentlySpeaking && !isRecentMessageControl) {
                this.isAiSpeaking = true
                this.clearUserSilenceTimer()
                this.playAnim('talk')
              } else if (!isSpeaking && this.isAiSpeaking && !this.isAiCurrentlySpeaking && !isRecentMessageControl) {
                // 只有在消息处理没有控制状态且不是最近的消息控制时才允许音频流检测切换
                this.isAiSpeaking = false
                this.playAnim('idle')
              }
            }
          },

          [VERTC.events.onRoomBinaryMessageReceived]: (e) => {
            try {

              const msg = tlv2String(e.message);

              const jsonData = JSON.parse(msg.value);
              const data = jsonData.data?.[0];

              if (!data || !data.text) {
                console.warn("Invalid or incomplete data received.");
                return;
              }
              // 提取所有需要的字段
              const text = data.text || '';
              const definite = data.definite === true;
              const paragraph = data.paragraph === true;
              const sequence = data.sequence || 0;
              const userId = data.userId || '';
              let decodedText = text;
              try {
                decodedText = decodeURIComponent(text);
              } catch (error) {
                decodedText = text;
              }
              if (!text || !text.trim()) return;

              const isAiSubtitle = userId.startsWith(this.botName);
              if (isAiSubtitle) {
                if (sequence < this.subtitleSequence) return;
                
                const trimmedText = decodedText.trim();
                this.subtitleSequence = sequence;
                
                // 清除之前的防抖定时器
                if (this.subtitleUpdateTimer) {
                  clearTimeout(this.subtitleUpdateTimer);
                  this.subtitleUpdateTimer = null;
                }
                
                if (paragraph) {
                  // 段落结束：立即更新字幕，3秒后清除
                  this.currentSubtitle = trimmedText;
                  if (this.subtitleClearTimer) {
                    clearTimeout(this.subtitleClearTimer);
                  }
                  this.subtitleClearTimer = setTimeout(() => {
                    this.currentSubtitle = '';
                    this.subtitleSequence = 0;
                  }, 3000);
                } else {
                  // 流式更新：使用防抖，减少DOM更新频率（每200ms最多更新一次）
                  this.subtitleUpdateTimer = setTimeout(() => {
                    this.currentSubtitle = trimmedText; // 使用闭包捕获最新的trimmedText
                    this.subtitleUpdateTimer = null;
                  }, 200);
                }
              } else {
                this.clearSubtitleState();
              }

              // 无论 definite 是否为 true，都更新当前索引的内容
              this.msgHis[this.msgHisIndex] = {
                userId: userId,
                text: decodedText, // 确保覆盖或追加逻辑正确
              };

              // 如果是最终段落，移动到下一个索引
              if (definite) {
                this.msgHisIndex += 1;
              }
              /*       // 解析 TLV 格式的消息
                    const msg = tlv2String(e.message);
                    console.log("TLV Parsed Result:", msg);
      
                    // 解析 JSON 数据
                    const jsonData = JSON.parse(msg.value);
                    console.log("Parsed JSON Data:", jsonData);
      
                    const data = jsonData.data[0];
      
                    // 检查数据完整性
                    if (!data || !data.text) {
                      console.warn("Invalid or incomplete data received.");
                      return;
                    }
      
                    // 更新会话历史记录
                    if (!this.msgHis[this.msgHisIndex] && data.definite) {
                      return;
                    }
                    if (!data.definite) {
                      this.msgHis[this.msgHisIndex] = {
                        userId: data.userId,
                        text: decodeURIComponent(data.text),
                      };
                    } else {
                      this.msgHisIndex += 1;
                    }
       */
              // AI / 用户说话状态与动画逻辑
              if (data.userId.startsWith(this.botName)) {
                // 埋点：AI面试开始（收到第一条AI消息且definite为true时）
                if (data.definite && !this.isInterviewStartedTracked) {
                  this.isInterviewStartedTracked = true
                  const interviewId = this.$store.state.interviewState.interviewId
                  const currentJob = this.$store.state.interviewState.currentInterviewJob
                  const positionId = currentJob?.id || currentJob?.job_id || ''
                  if (interviewId && positionId && this.$tracking) {
                    this.$tracking.trackAiInterviewStart({
                      interviewId: interviewId,
                      positionId: positionId
                    })
                  }
                }
                
                if (!data.definite) {
                  // AI 开始说话 - 只有在真正有内容且之前不在说话时才切换
                  if (!this.isAiCurrentlySpeaking) {
                    this.isAiCurrentlySpeaking = true;
                    this.isAiSpeaking = true;
                    this.clearUserSilenceTimer();
                    this.forceSetAnimState('talk', '消息处理-开始');

                    // 如果这是倒计时最后 30 秒内，新开始的一轮 AI 发言，
                    // 且在最后30秒里用户已经说过话（userSpokeInLast30Seconds 为 true），
                    // 则认为这一轮更可能是“结束语”，等这轮说完后立刻结束面试。
                    const totalSeconds = this.leftMinutes * 60 + this.leftSeconds;
                    if (
                      totalSeconds > 0 &&
                      totalSeconds <= 30 &&
                      this.isFinalQuestionAsked &&
                      this.userSpokeInLast30Seconds
                    ) {
                      this.autoEndOnCurrentLast30AiTurn = true;
                    } else {
                      // 如果用户还没在最后30秒说过话（例如 AI 先在 30s 处发问），
                      // 或者当前并非处于最后30秒阶段，则这一轮不视为结束语。
                      this.autoEndOnCurrentLast30AiTurn = false;
                    }
                  }
                } else {
                  // definite: true 表示 AI 说完了当前这条消息
                  this.lastAiDefiniteTime = Date.now();
                  this.lastAiDefiniteMessageTime = Date.now();
                  // AI说完话计数+1
                  this.aiSpeechCount += 1;
                  
                  // 当AI说完第二句话时，初始化行为检测
                  if (!this.behaviorDetectionInitialized && this.aiSpeechCount >= 2) {
                    this.behaviorDetectionInitialized = true
                    setTimeout(() => {
                      this.initBehaviorDetection().catch(error => {
                        this.behaviorDetectionInitialized = false // 初始化失败，允许重试
                      })
                    }, 2000)
                  }
                  if (this.isAiCurrentlySpeaking) {
                    // 延迟 200ms 后切换到 idle 状态，确保与语音同步
                    setTimeout(() => {
                      if (this.isAiCurrentlySpeaking) {
                        this.isAiCurrentlySpeaking = false;
                        this.isAiSpeaking = false;
                        this.forceSetAnimState('idle', '消息处理-结束');
                        this.notifyAiSpeechFinished();
                        this.checkAndHandleAutoEnd();
                      }
                    }, 200);
                  } else {
                    // 如果 AI 不在说话状态，直接通知（可能是新的消息）
                    this.notifyAiSpeechFinished();
                  }
                }
              } else {
                // 用户消息检测
                if (!data.definite) {
                  // 用户开始说话
                  this.isUserSpeaking = true;
                  this.lastUserMessageTime = Date.now();
                  
                  // 清除停顿检测定时器
                  this.clearUserSilenceTimer();

                  // 标记用户已经在最后30秒内说过话，用于后续判断哪一轮 AI 话是"真正的结束语"
                  const totalSecondsForUser = this.leftMinutes * 60 + this.leftSeconds;
                  if (totalSecondsForUser > 0 && totalSecondsForUser <= 30 && this.isFinalQuestionAsked) {
                    this.userSpokeInLast30Seconds = true;
                  }
                } else {
                  // 用户说完一句话，更新最后消息时间
                  this.lastUserMessageTime = Date.now();
                  
                  // 埋点：AI面试答题提交（用户回答完成时）
                  if (this.isInterviewStartedTracked && this.$tracking) {
                    const interviewId = this.$store.state.interviewState.interviewId
                    if (interviewId) {
                      this.$tracking.trackAiInterviewAnswerSubmit({
                        interviewId: interviewId
                      })
                      this.answerSubmitCount++
                    }
                  }
                  
                  // 延迟检测用户是否真的说完了
                  setTimeout(() => {
                    const timeSinceLastMessage = Date.now() - this.lastUserMessageTime;
                    if (timeSinceLastMessage >= 1000) {
                      this.isUserSpeaking = false;
                      this.startUserSilenceTimer();
                    }
                  }, 1000);
                }
              }
            } catch (error) {
              console.error("Error processing room message:", error);
            }
          },
          [VERTC.events.onUserStartAudioCapture]: (e) => {
          },
          [VERTC.events.onUserStopAudioCapture]: (e) => {
          },
          [VERTC.events.onError]: (e) => {
            this.rtcStatusMessage = `RTC 错误: ${e.msg || e.errorCode}`
            this.$message.error(`RTC 错误: ${e.msg || e.errorCode}`)
          },
          [VERTC.events.onWarning]: (e) => {
            this.$message.warning(`RTC 警告: ${e.msg || e.errorCode}`)
          },
          [VERTC.events.onConnectionStateChanged]: (state, reason) => {
            this.rtcStatusMessage = `连接状态: ${state}`
          },
          [VERTC.events.onNetworkTypeChanged]: (type) => {
            this.rtcStatusMessage = `网络类型: ${type}`
          }
        }

        RtcClient.addEventListeners(this.rtcEventListeners)

        this.isRtcInitialized = true
        this.rtcStatusMessage = 'RTC 初始化完成'
      } catch (error) {
        this.rtcStatusMessage = `RTC 初始化失败: ${error.message || error}`
        this.$message.error(`RTC 初始化失败: ${error.message || error}`)
      }
    },

    async connectAndStartAi() {
      if (!this.isRtcInitialized || this.isRtcConnected) return

      try {
        this.rtcStatusMessage = '连接房间并启动 AI 中...'

        const token = this.token
        const userId = this.userId
        const roomId = this.roomId
        const appId = this.appId

        const devices = await RtcClient.getDevices()
        const audioInputs = devices?.audioInputs || []
        if (audioInputs.length === 0) {
          throw new Error('未找到可用的麦克风设备')
        }
        const defaultMic = audioInputs[0]

        await RtcClient.joinRoom({ token })
        // username: `user_${userId}`

        this.microphone = defaultMic

        await RtcClient.startAudioCapture(defaultMic)
        this.isRtcConnected = true
        this.rtcStatusMessage = '已连接，正在启动 AI Bot...'

/*         const botConfig = {
          TaskId: userId,
          RoomId: roomId,
          AppId: appId,
          AgentConfig: {
            TargetUserId: [userId],
            UserId: this.botName,
            WelcomeMessage: this.welcomeMsg,
          },
          Config: { 
            thinking: "disabled",
            LLMConfig: {
              Mode: 'ArkV3',
              EndPointId: 'ep-20250617004108-c7wqs',
              MaxTokens: 4096,
              Temperature: 0.6,
              frequency_penalty: 0.2,
              presence_penalty: 0.1,
              TopP: 0.7,
              SystemMessages: [this.prompt],
              ModelName: 'doubao-seed-1-6-flash-250615',

            },
            TTSConfig: {
              Provider: 'volcano',
              ProviderParams: {
                app: { AppId: '7386821752', Cluster: 'volcano_tts' },
                audio: { voice_type: 'ICL_zh_female_huopodiaoman_tob', speed_ratio: 1 },
              },
              IgnoreBracketText: [1, 2, 3, 4, 5],
            },
            ASRConfig: {
              Provider: 'volcano',
              ProviderParams: {
                Mode: 'bigmodel',
                AppId: '7386821752',
                AccessToken: '3_Vx6Blujp4H8Vos3V42B05-tm60g377',
                ApiResourceId: 'volc.bigasr.sauc.duration',
                StreamMode: 0
              },
            },
            InterruptMode: 0,
          },
        } */
        const botConfig = {
          TaskId: userId,
          RoomId: roomId,
          AppId: appId,
          AgentConfig: {
            TargetUserId: [userId],
            UserId: this.botName,
            WelcomeMessage: this.welcomeMsg,
            AnsMode: 2
          },
          Config: {
            thinking: "disabled",
            LLMConfig: {
              ThinkingType: 'disabled',
              Mode: 'ArkV3',
              EndPointId: 'ep-20251031105537-szklb',
              MaxTokens: 128,
              HistoryLength: 20,
              Temperature: 0.6,
              TopP: 0.85,
              SystemMessages: [this.languagePrompt],
              ModelName: 'doubao-seed-1-6-251015',
      Prefill: true,
      reasoning_effort:"minimal",
            },
            TTSConfig: {
              Provider: "volcano_bidirection",
      ProviderParams: {
        app: {
          appid: "7386821752",
          token: "3_Vx6Blujp4H8Vos3V42B05-tm60g377",
        },
        audio: {
          voice_type: "ICL_zh_female_rouguhunshi_v1_tob",
          speech_rate: 0,
        },
        ResourceId: "volc.service_type.10029",
      },
              // Provider: 'volcano',
              // ProviderParams: {
              //   app: { AppId: '7386821752', Cluster: 'volcano_tts' },
              //   audio: { voice_type: 'ICL_zh_female_huopodiaoman_tob', speed_ratio: 1 },
              // },
              // IgnoreBracketText: [1, 2, 3, 4, 5],
            },
            ASRConfig: {
              Provider: 'volcano',
              ProviderParams: {
                Mode: 'bigmodel',
                AppId: '7386821752',
                AccessToken: '3_Vx6Blujp4H8Vos3V42B05-tm60g377',
                ApiResourceId: 'volc.bigasr.sauc.duration',
                StreamMode: 2,
                enable_nonstream: true
              },
              VADConfig: {
                AIVAD: true, 
                SilenceTime: 800, 
              },
            },
            InterruptMode: 1,
          },
};
        await RtcClient.startAudioBot(roomId, userId, botConfig)
        this.rtcStatusMessage = 'AI 面试官已准备就绪'
        
        // 埋点：AI面试开始（在AI启动后，等待收到第一题时再上报）
      } catch (error) {
        this.rtcStatusMessage = `连接/启动失败: ${error.message || error}`
        this.$message.error(`连接或启动 AI 失败: ${error.message || error}`)
        await this.disconnectAndStopAi()
      }
    },

    async disconnectAndStopAi() {
      if (!this.isRtcConnected && !RtcClient.audioBotEnabled) {
        await this.forceCloseAllMediaStreams()
        return
      }

      try {
        this.rtcStatusMessage = '正在停止 AI 并断开连接...'

        const userId = this.userId
        const roomId = this.roomId

        await RtcClient.stopAudioBot(roomId, userId)
        this.isAiSpeaking = false
        this.playAnim('idle')

        await RtcClient.stopAudioCapture()

        await RtcClient.leaveRoom()

        this.isRtcConnected = false
        this.rtcStatusMessage = '已断开连接'
      } catch (error) {
        this.rtcStatusMessage = `停止/断开失败: ${error.message || error}`
        this.$message.error(`停止 AI 或断开连接失败: ${error.message || error}`)
      } finally {
        // 无论成功或失败，都要释放所有资源
        try {
          // 停止噪音检测
          this.stopNoiseDetection()
          // 停止截图定时器
          this.stopScreenshotTimer()
          // 停止行为检测
          this.stopBehaviorDetection()
          // 清除用户停顿检测定时器
          this.clearUserSilenceTimer()
          // 强制释放所有媒体资源
          await this.forceCloseAllMediaStreams()
        } catch (error) {
          console.error('释放资源时出错:', error)
        }
        // 重置状态
        this.isRtcConnected = false
        this.isAiSpeaking = false
      }
    },

    async interruptAi() {
      if (!this.isRtcConnected || !this.isAiSpeaking) return

      try {
        this.rtcStatusMessage = '正在打断 AI...'

        const userId = this.userId
        const roomId = this.roomId

        await RtcClient.stopAudioVoice(roomId, userId)
        this.rtcStatusMessage = '已请求打断 AI'
      } catch (error) {
        console.error('打断 AI 失败:', error)
        this.rtcStatusMessage = `打断 AI 失败: ${error.message || error}`
        this.$message.error(`打断 AI 失败: ${error.message || error}`)
      }
    },
    
    /**
     * 启动用户停顿检测定时器（5秒）
     */
    startUserSilenceTimer() {
      this.clearUserSilenceTimer()
      
      if (this.isUserSpeaking || this.isAiSpeaking || this.isAiCurrentlySpeaking) {
        return
      }
      
      this.userSilenceTimer = setTimeout(async () => {
        if (!this.isUserSpeaking && !this.isAiSpeaking && !this.isAiCurrentlySpeaking && this.isRtcConnected) {
          try {
            await RtcClient.finishSpeechRecognition(this.roomId, this.userId)
          } catch (error) {
            console.error('[用户停顿检测] 完成语音识别失败:', error)
          }
        }
        this.userSilenceTimer = null
      }, 5000) // 5秒
    },
    
    clearUserSilenceTimer() {
      if (this.userSilenceTimer) {
        clearTimeout(this.userSilenceTimer)
        this.userSilenceTimer = null
      }
    },
    async sendLastQuestionToAI() {
      await RtcClient.sendTextToSpeech('同学回答的很全面，本次面试表现很优秀，由于时间关系，我们本次面试到此结束啦，同学可以点击结束面试按钮查看本次面试表现，祝同学找到心仪的工作，加油欧', 2);
      await RtcClient.stopAudioCapture()//停止音频采集
    },

    // 修复convertToTLV方法（确保存在且正确转换）
    convertToTLV(data) {
      const jsonString = JSON.stringify(data);
      const encoder = new TextEncoder();
      return encoder.encode(jsonString).buffer; // 使用.buffer获取ArrayBuffer
    },

    // 倒计时30秒时触发
    handleThirtySecondsLeft() {
      this.isFinalQuestionAsked = true; // 标志：已经进入最后一个阶段
      // 重置与最后30秒结束策略相关的状态
      this.userSpokeInLast30Seconds = false;
      this.autoEndOnCurrentLast30AiTurn = false;
      // 停止行为检测
      try {
        this.stopBehaviorDetection()
      } catch (error) {
        console.warn('[倒计时30秒] 停止行为检测时发生错误，但不影响面试流程:', error)
      }
      // this.sendLastQuestionToAI();
    },

    // 倒计时结束时处理
    async handleTimerEnded() {
      
      // 情况1：用户在说话，等待用户说完并AI回复完
      const userIsSpeaking = this.isUserSpeaking || (this.lastUserMessageTime && Date.now() - this.lastUserMessageTime < 2000);
      
      if (userIsSpeaking) {
        await this.waitForUserToFinish();
        await this.waitForAiToFinish();
        // 再额外等待一小段时间，让最后一句语音完整播完
        await new Promise(resolve => setTimeout(resolve, 4000));
        this.endInterviewWithTimeMessage();
        return;
      }

      // 情况2：AI在说话，等待AI说完
      if (this.isAiSpeaking || this.isAiCurrentlySpeaking) {
        await this.waitForAiToFinish();
        // 再额外等待一小段时间，让最后一句语音完整播完
        await new Promise(resolve => setTimeout(resolve, 4000));
        this.endInterviewWithTimeMessage();
        return;
      }

      // 情况3：其他情况，立即结束
      this.endInterviewWithTimeMessage();
    },

    // 等待用户说完
    async waitForUserToFinish() {
      const maxWait = 30000; // 最多等待30秒
      const interval = 500;
      let waited = 0;

      while (waited < maxWait) {
        const userIsSpeaking = this.isUserSpeaking || (this.lastUserMessageTime && Date.now() - this.lastUserMessageTime < 2000);
        if (!userIsSpeaking) {
          // 再等待2秒确认
          await new Promise(resolve => setTimeout(resolve, 2000));
          const stillNotSpeaking = !this.isUserSpeaking && (!this.lastUserMessageTime || Date.now() - this.lastUserMessageTime >= 2000);
          if (stillNotSpeaking) {
            return;
          }
        }
        await new Promise(resolve => setTimeout(resolve, interval));
        waited += interval;
      }
    },

    // 统一的“时间到结束面试”逻辑，避免多处重复触发
    endInterviewWithTimeMessage() {
      if (this.hasInterviewEndMessageShown) {
        return;
      }
      this.hasInterviewEndMessageShown = true;

      RtcClient.stopAudioCapture().catch((e) => {
        console.error('结束面试时停止音频采集失败:', e);
      });

      this.$message.info({
        message: '因为时间的原因，我们的面试到此结束，感谢您参加此次面试',
        duration: 5000,
        onClose: () => this.overInterview()
      });
    },

    // 通知所有等待AI说完的Promise
    notifyAiSpeechFinished() {
      // 解析所有等待的Promise
      while (this.aiSpeechFinishResolvers.length > 0) {
        const resolve = this.aiSpeechFinishResolvers.shift();
        if (resolve) {
          resolve();
        }
      }
    },

    // 检查并处理自动结束面试的逻辑
    checkAndHandleAutoEnd() {
      // 如果这一轮是"最后30秒内的结束语候选"，且还没到真正的 0 秒倒计时，
      // 那么在 AI 说完并完成动画切换后，直接结束面试。
      const totalSecondsAfter = this.leftMinutes * 60 + this.leftSeconds;
      const shouldAutoEnd = this.autoEndOnCurrentLast30AiTurn &&
                            totalSecondsAfter > 0 &&
                            totalSecondsAfter <= 30 &&
                            !this.hasInterviewEndMessageShown;

      if (shouldAutoEnd) {
        this.autoEndOnCurrentLast30AiTurn = false;
        // 额外缓冲 3 秒，避免把同一轮里的后续句子或新一轮发言截断
        setTimeout(() => {
          // 如果缓冲期间又有新的 AI 发言（正在说话），则放弃本次自动结束
          if (this.isAiCurrentlySpeaking || this.isAiSpeaking) {
            return;
          }
          if (!this.hasInterviewEndMessageShown) {
            this.endInterviewWithTimeMessage();
          }
        }, 3000);
      } else {
        // 如果不是结束语候选，重置标记，避免误用
        this.autoEndOnCurrentLast30AiTurn = false;
      }
    },

    // 等待AI说完（基于消息definite字段，更准确）
    async waitForAiToFinish() {
      
      // 先等待一小段时间，确保状态已更新
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 多次检查AI说话状态，确保准确性（检查3次，每次间隔200ms）
      let isAiCurrentlySpeaking = false;
      for (let i = 0; i < 3; i++) {
        isAiCurrentlySpeaking = this.isAiSpeaking || this.isAiCurrentlySpeaking;
        if (isAiCurrentlySpeaking) {
          break;
        }
        if (i < 2) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }
      
      // 优先检查：如果AI正在说话，必须等待AI说完（忽略旧的definite消息）
      if (isAiCurrentlySpeaking) {
        
        // 创建一个Promise，等待definite消息触发
        let resolvePromise = null;
        const waitForDefinite = new Promise((resolve) => {
          resolvePromise = resolve;
          this.aiSpeechFinishResolvers.push(resolve);
        });

        // 同时设置超时（最多等待30秒）
        const timeout = new Promise((resolve) => {
          setTimeout(() => {
            // 从队列中移除这个resolver
            const index = this.aiSpeechFinishResolvers.indexOf(resolvePromise);
            if (index > -1) {
              this.aiSpeechFinishResolvers.splice(index, 1);
            }
            resolve();
          }, 30000);
        });

        // 等待definite消息或超时（哪个先到执行哪个）
        await Promise.race([waitForDefinite, timeout]);
        
      } else {
        // 如果AI当前不在说话，且最近有definite消息（2秒内），说明AI刚说完
        // 但要确保不是状态更新延迟导致的误判
        if (this.lastAiDefiniteTime && Date.now() - this.lastAiDefiniteTime < 2000) {
          // 再等待500ms，再次确认AI不在说话
          await new Promise(resolve => setTimeout(resolve, 500));
          const stillNotSpeaking = !this.isAiSpeaking && !this.isAiCurrentlySpeaking;
          
          if (stillNotSpeaking) {
            await new Promise(resolve => setTimeout(resolve, 2000));
            return;
          } else {
            // 状态更新后发现AI在说话，转去等待definite消息
            
            // 创建Promise等待definite消息
            let resolvePromise = null;
            const waitForDefinite = new Promise((resolve) => {
              resolvePromise = resolve;
              this.aiSpeechFinishResolvers.push(resolve);
            });

            const timeout = new Promise((resolve) => {
              setTimeout(() => {
                const index = this.aiSpeechFinishResolvers.indexOf(resolvePromise);
                if (index > -1) {
                  this.aiSpeechFinishResolvers.splice(index, 1);
                }
                resolve();
              }, 30000);
            });

            await Promise.race([waitForDefinite, timeout]);
          }
        }
      }
      
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // 辅助验证：如果音频流状态显示AI仍在说话，再等待一下（最多5秒）
      let checkCount = 0;
      while ((this.isAiSpeaking || this.isAiCurrentlySpeaking) && checkCount < 10) {
        await new Promise(resolve => setTimeout(resolve, 500));
        checkCount++;
      }
    },

    // 开始定时拍照
    startScreenshotTimer() {
      this.screenshotCount = 0
      this.screenshotUrls = []
      
      // 延迟3秒后拍第一张照片，让视频有时间加载
      setTimeout(() => {
        this.takeScreenshot()
      }, 3000)
      
      // 设置定时器，每隔一分钟拍一次
      this.screenshotTimer = setInterval(() => {
        if (this.screenshotCount < this.maxScreenshots) {
          this.takeScreenshot()
        } else {
          this.stopScreenshotTimer()
        }
      }, 60000) // 60秒 = 1分钟
    },

    

    // 停止定时拍照
    stopScreenshotTimer() {
      if (this.screenshotTimer) {
        clearInterval(this.screenshotTimer)
        this.screenshotTimer = null
      }
      // 清理截图重试定时器
      if (this.screenshotRetryTimeoutId) {
        clearTimeout(this.screenshotRetryTimeoutId)
        this.screenshotRetryTimeoutId = null
      }
    },

    // 拍照并上传
    async takeScreenshot() {
      try {
        
        // 获取视频元素 - 通过查找页面中的所有video元素
        const allVideos = document.querySelectorAll('video')
        
        if (allVideos.length === 0) {
          console.error('页面中没有找到任何video元素')
          return
        }

        // 使用第一个可用的视频元素
        const videoElement = allVideos[0]

        // 检查视频是否已加载
        if (videoElement.readyState < 2) {
          console.warn('视频尚未加载完成，readyState:', videoElement.readyState)
          // Safari可能需要更多时间加载，延迟重试
          if (this.screenshotRetryTimeoutId) {
            clearTimeout(this.screenshotRetryTimeoutId)
          }
          this.screenshotRetryTimeoutId = setTimeout(() => this.takeScreenshot(), 1000)
          return
        }

        // 创建canvas来捕获视频帧
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d', { willReadFrequently: true })
        
        // 设置canvas尺寸
        canvas.width = videoElement.videoWidth || videoElement.clientWidth
        canvas.height = videoElement.videoHeight || videoElement.clientHeight
        
        
        // 绘制视频帧到canvas
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height)
        
        // 将canvas转换为blob
        const blob = await new Promise(resolve => {
          canvas.toBlob(resolve, 'image/jpeg', 0.8)
        })
        
        
        if (!blob) {
          console.error('无法生成图片blob')
          return
        }

        // 创建文件对象
        const file = new File([blob], `screenshot_${Date.now()}.jpg`, {
          type: 'image/jpeg'
        })

        // 构造上传参数
        const formData = new FormData()
        formData.append('file', file)

        
        // 调用上传接口
        const response = await lxUploadFile(formData)

        if (response && response.data && response.data.code === 1 && response.data.data && response.data.data.url) {
          const imageUrl = response.data.data.url
          // 使用面试开始时间计算当前第几秒，若无开始时间则回退为0秒
          const baseStartTime = this.startTimestamp || this.interviewStartTime
          const screenshotTime = baseStartTime ? Math.floor((Date.now() - baseStartTime) / 1000) : 0

          // 存储截图信息
          this.screenshotUrls.push({
            imageUrl,
            screenshotTime
          })

          this.screenshotCount++

          // 立即保存截图到数据库
          await this.saveSingleScreenshot(imageUrl, screenshotTime)
        } else {
          console.error('截图上传失败:', response)
        }
      } catch (error) {
        console.error('拍照失败:', error)
      }
    },

    // 保存单张截图到数据库
    async saveSingleScreenshot(imageUrl, screenshotTime) {
      try {
        const interviewId = this.$store.state.interviewState.interviewId
        
        await saveInterviewScreenshot({
          interview_id: interviewId,
          image_url: imageUrl,
          screenshot_time: screenshotTime
        })
        
      } catch (error) {
        console.error('保存截图到数据库失败:', error)
      }
    },

    // 保存面试截图（保留用于批量保存，但主要逻辑已改为单张保存）
    async saveScreenshots() {
      if (this.screenshotUrls.length === 0) {
        return
      }

      try {
        const interviewId = this.$store.state.interviewState.interviewId

        // 批量保存截图
        const savePromises = this.screenshotUrls.map(screenshot => {
          return saveInterviewScreenshot({
            interview_id: interviewId,
            image_url: screenshot.imageUrl,
            screenshot_time: screenshot.screenshotTime
          })
        })

        const results = await Promise.all(savePromises)
        
        // 检查是否有保存失败的
        const failedSaves = results.filter(result => 
          !result.data || result.data.code !== 0
        )
        
        if (failedSaves.length > 0) {
          console.warn('部分截图保存失败:', failedSaves)
        }
      } catch (error) {
        console.error('保存截图失败:', error)
      }
    },
    
    // ========== 行为监测相关方法 ==========
    
    async preloadBehaviorDetectionResources() {
      // 如果已经加载过，直接返回
      if (this.behaviorDetectionResourcesLoaded && this.faceLandmarker) {
        return
      }
      
      try {
        const wasmPath = '/mediapipe-wasm'
        const vision = await FilesetResolver.forVisionTasks(wasmPath)
        const modelUrl = '/face_landmarker.task'
        const delegate = this.shouldUseGPU() ? 'GPU' : 'CPU'
        
        this.faceLandmarker = await FaceLandmarker.createFromOptions(vision, {
          baseOptions: {
            modelAssetPath: modelUrl,
            delegate: delegate
          },
          runningMode: 'VIDEO',
          numFaces: 2,
          minFaceDetectionConfidence: 0.75, // 提高置信度，过滤假脸
          minFacePresenceConfidence: 0.75
        })
        
        this.behaviorDetectionResourcesLoaded = true
      } catch (error) {
        // 静默失败，不显示错误提示，不影响页面运行
        console.warn('[行为检测] 资源预加载失败，将在使用时重试:', error)
        this.faceLandmarker = null
        this.behaviorDetectionResourcesLoaded = false
      }
    },
    
    /**
     * 初始化行为检测（启动检测循环）
     * 如果资源未加载，会先加载资源
     */
    async initBehaviorDetection() {
      try {
        // 如果资源未加载，先加载资源
        if (!this.behaviorDetectionResourcesLoaded || !this.faceLandmarker) {
          await this.preloadBehaviorDetectionResources()
        }
        
        // 如果资源加载失败，退出
        if (!this.faceLandmarker) {
          this.detectionDisabled = true
          return
        }
        
        this.detectionErrorCount = 0
        this.detectionDisabled = false
        
        this.getDetectionVideo(20, 1000)
        
        this.startDetectionLoop()
        
        this.$message.success({
          message: '行为检测已启动',
          duration: 3000
        })
      } catch (error) {
        console.error('[行为检测] 初始化失败:', error)
        this.faceLandmarker = null
        this.detectionVideo = null
        this.detectionDisabled = true
        this.behaviorDetectionResourcesLoaded = false
      }
    },
    
    getDetectionVideo(maxRetries = 30, retryDelay = 1000) {
      let retries = 0
      const tryGetVideo = () => {
        try {
          const videoContainer = document.getElementById('interview_ing_video')
          if (videoContainer) {
            const existingVideo = videoContainer.querySelector('video')
            if (existingVideo && existingVideo.srcObject) {
              if (existingVideo.srcObject) {
                this.detectionVideo = existingVideo
                return true
              }
            }
          }
          
          const allVideos = document.querySelectorAll('video')
          for (const video of allVideos) {
            if (video.srcObject && video.readyState >= 2) {
              this.detectionVideo = video
              return true
            }
          }
          // 继续重试
          if (retries < maxRetries) {
            retries++
            setTimeout(tryGetVideo, retryDelay)
            return false
          }
          this.detectionVideo = null
          return false
        } catch (error) {
          console.error('[行为检测] 查找视频元素失败:', error)
          this.detectionVideo = null
          return false
        }
      }
      return tryGetVideo()
    },
    
    startDetectionLoop() {
      if (this.detectionTimeoutId) {
        clearTimeout(this.detectionTimeoutId)
      }
      
      const detect = async () => {
        if (!this.faceLandmarker) {
          if (!this.detectionDisabled) {
            this.detectionTimeoutId = setTimeout(detect, this.detectionInterval)
          }
          return
        }
        
        if (!this.detectionVideo) {
          const found = this.getDetectionVideo(5, 500)
          if (!found) {
            this.detectionTimeoutId = setTimeout(detect, this.detectionInterval)
            return
          }
        }
        
        if (this.detectionDisabled) {
          return
        }
        
        if (!this.detectionVideo.srcObject || this.detectionVideo.readyState < 2) {
          // 视频未准备好，继续等待
          this.detectionTimeoutId = setTimeout(detect, this.detectionInterval)
          return
        }
        const isInterviewStarted = this.startTimestamp != null && this.startTimestamp > 0
        if (!isInterviewStarted) {
          this.detectionTimeoutId = setTimeout(detect, this.detectionInterval)
          return
        }
        
        try {
          const now = performance.now()
          const results = this.faceLandmarker.detectForVideo(this.detectionVideo, now)
          // 非阻塞处理检测结果，不等待完成
          this.handleDetection(results).catch(error => {
            console.error('[行为检测] 处理检测结果失败:', error)
          })
          this.detectionErrorCount = 0
          this.detectionTimeoutId = setTimeout(detect, this.detectionInterval)
        } catch (error) {
          const errorMessage = error?.message || String(error)
          const isVideoError = errorMessage.includes('video') || errorMessage.includes('Video') || 
                              errorMessage.includes('element') || !this.detectionVideo
          
          // 如果是视频元素相关的错误，不增加错误计数，继续查找
          if (isVideoError) {
            console.warn(`[行为检测] 视频元素错误，重新查找:`, errorMessage)
            this.detectionVideo = null
            this.detectionTimeoutId = setTimeout(detect, this.detectionInterval)
            return
          }
          
          // 其他错误统一处理：计数，超过5次停止
          this.detectionErrorCount += 1
          
          if (this.detectionErrorCount >= 5) {
            this.detectionDisabled = true
            this.faceLandmarker = null
            return
          }
          // 错误未达到5次，继续重试
          const retryDelay = Math.min(this.errorRetryDelay * this.detectionErrorCount, 10000)
          
          if (this.detectionErrorCount >= 3) {
            this.detectionInterval = 2000
          }
          
          this.detectionTimeoutId = setTimeout(detect, retryDelay)
        }
      }
      
      detect()
    },
    
    getValidFaceCount(results) {
      if (!results || !results.faceLandmarks || results.faceLandmarks.length === 0) return 0
      const faces = results.faceLandmarks
      if (faces.length === 1) return 1

      // 计算所有脸的中心点
      const getCenter = (landmarks) => {
        let minX = 1, maxX = 0, minY = 1, maxY = 0
        for (const p of landmarks) {
          if (p.x < minX) minX = p.x
          if (p.x > maxX) maxX = p.x
          if (p.y < minY) minY = p.y
          if (p.y > maxY) maxY = p.y
        }
        return { x: (minX + maxX) / 2, y: (minY + maxY) / 2 }
      }

      const centers = faces.map(getCenter)
      const DISTANCE_THRESHOLD = 0.3 // 距离阈值：30%屏幕宽度
      
      // 简单聚类：以第一张脸为基准
      const baseCenter = centers[0]
      let validCount = 1 

      for (let i = 1; i < centers.length; i++) {
        const dist = Math.hypot(centers[i].x - baseCenter.x, centers[i].y - baseCenter.y)
        // 只有距离足够远（>30%屏幕宽度），才认为是真的第二个人
        if (dist > DISTANCE_THRESHOLD) {
          validCount++
        }
      }
      return validCount
    },
    
    async handleDetection(results) {
      const STATUS = { ABSENT: 'ABSENT', MULTIPLE: 'MULTIPLE' }
      
      const confirmedCount = this.getValidFaceCount(results)
      
      // 场景1：离开后回来 (0 -> >0)
      if (this.isUserGone && confirmedCount > 0) {
        this.isUserGone = false
        this.lastReportedCount = confirmedCount
        // 清除离开警告状态
        this.lastLeaveWarnStatus = null
        this.currentConfirmedStatus = null
      }
      
      // 场景2：离开画面 (N -> 0)
      else if (confirmedCount === 0) {
        if (!this.isUserGone) {
          const previousStatus = this.currentConfirmedStatus
          
          if (previousStatus !== STATUS.ABSENT && this.lastLeaveWarnStatus !== STATUS.ABSENT) {
            const randomMessage = getRandomMessage(LEAVE_SCREEN_MESSAGES)
            // 非阻塞发送，不等待结果
            RtcClient.insertMessageToAI(this.roomId, this.userId, randomMessage, 1).catch(error => {
              console.error('[行为检测] 发送离开提示失败:', error)
            })
            this.lastLeaveWarnStatus = STATUS.ABSENT
            this.currentConfirmedStatus = STATUS.ABSENT
          }
          
          this.isUserGone = true
          this.lastReportedCount = 0
          
          // 清除多人警告状态
          if (previousStatus === STATUS.MULTIPLE) {
            this.lastMultipleWarnStatus = null
          }
        }
      }
      
      // 场景3：人数变化（包括多人检测）
      else if (confirmedCount > 0 && confirmedCount !== this.lastReportedCount && !this.isUserGone) {
        const previousStatus = this.currentConfirmedStatus
        
        if (confirmedCount > 1) {
          // 多人检测
          if (previousStatus !== STATUS.MULTIPLE && this.lastMultipleWarnStatus !== STATUS.MULTIPLE) {
            const randomMessage = getRandomMultiplePeopleMessage(confirmedCount)
            // 非阻塞发送，不等待结果，使用中等优先级（2），避免立即打断AI
            RtcClient.insertMessageToAI(this.roomId, this.userId, randomMessage, 1).catch(error => {
              console.error('[行为检测] 发送多人提示失败:', error)
            })
            this.lastMultipleWarnStatus = STATUS.MULTIPLE
            this.currentConfirmedStatus = STATUS.MULTIPLE
          }
        } else {
          // 单人（恢复正常）
          if (previousStatus === STATUS.MULTIPLE) {
            this.lastMultipleWarnStatus = null
            this.currentConfirmedStatus = null
          }
        }
        
        this.lastReportedCount = confirmedCount
      }
    },
    
    shouldUseGPU() {
      try {
        const hardwareConcurrency = navigator.hardwareConcurrency || 2
        const deviceMemory = navigator.deviceMemory || 4
        
        if (hardwareConcurrency <= 2 || deviceMemory < 4) {
          return false
        }
        
        // 检查 WebGL 支持
        const canvas = document.createElement('canvas')
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
        if (!gl) {
          return false
        }
        
        const gl2 = canvas.getContext('webgl2')
        if (!gl2 && hardwareConcurrency <= 4) {
          return false
        }
        
        // 检查是否是软件渲染
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
        if (debugInfo) {
          const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
          if (renderer && renderer.toLowerCase().includes('swiftshader')) {
            return false
          }
        }
        
        return true
      } catch (error) {
        return false
      }
    },
    
    stopBehaviorDetection() {
      if (this.detectionTimeoutId) {
        clearTimeout(this.detectionTimeoutId)
        this.detectionTimeoutId = null
      }
      if (this.faceLandmarker) {
        try {
          this.faceLandmarker = null
        } catch (error) {
          // 忽略清理错误
        }
      }
      this.detectionVideo = null
      this.currentConfirmedStatus = null
      this.detectionErrorCount = 0
      this.detectionDisabled = false
      this.lastReportedCount = -1
      this.isUserGone = false
    },
  },
  computed: {
    prompt() {
      if (this.$store.state.interviewState.interviewLanguage == 2) {
        return this.$store.state.interviewState.prompt + '现在要求使用英语进行面试，所有问题都必须使用英语进行提问并且后面的提问中不再使用中文。Now please speak in English.'
      }
      return this.$store.state.interviewState.prompt
    },
    languagePrompt(){
      if (this.$store.state.interviewState.interviewLanguage == 2) {
        return '现在要求使用英语进行面试，所有问题都必须使用英语进行提问并且后面的提问中不再使用中文。Now please speak in English.'
      }
      return ''
    },
    welcomeMsg() {
      if (this.$store.state.interviewState.interviewLanguage == 2) {
        return 'Hello, I am your AI interviewer Cathy. Are you ready to start the interview?'
      }
      return '你好，我是你的AI面试官 Cathy，请问准备好开始面试了吗？'
    }
  },
  beforeDestroy() {
    if (this.subtitleClearTimer) {
      clearTimeout(this.subtitleClearTimer)
      this.subtitleClearTimer = null
    }
    this.stopNoiseDetection()
    this.stopScreenshotTimer()
    this.clearUserSilenceTimer()

    // 清理阶段性 Prompt 记录
    this.executedPromptTimes.clear()
    
    // 清理 RTC 事件监听器
    if (this.rtcEventListeners && RtcClient.removeEventListeners) {
      try {
        RtcClient.removeEventListeners(this.rtcEventListeners)
        this.rtcEventListeners = null
      } catch (error) {
        console.warn('[组件销毁] 移除 RTC 事件监听器时发生错误:', error)
      }
    }
    
    // 清理权限状态监听器
    if (this.permissionStatus && this.permissionStatus.onchange) {
      this.permissionStatus.onchange = null
      this.permissionStatus = null
    }
    
    // 清理 AI 说完的 Promise resolver 队列
    this.aiSpeechFinishResolvers = []
    
    // 停止行为检测（失败不影响后续清理）
    try {
      this.stopBehaviorDetection()
    } catch (error) {
      console.warn('[组件销毁] 停止行为检测时发生错误，但不影响其他清理流程:', error)
    }

    // 页面卸载时也做一次彻底清理，避免浏览器保留"正在访问摄像头"的提示
    if (this.$refs && this.$refs.videoRef && this.$refs.videoRef.releaseResources) {
      this.$refs.videoRef.releaseResources().catch(() => { })
    }
    if (typeof this.forceCloseAllMediaStreams === 'function') {
      this.forceCloseAllMediaStreams()
    }
  },

}
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
@media (max-width: 1600px) {
  .scaler {
    transform-origin: top left;
    transform: scale(0.67);
    /* pointer-events: none;  */
  }
}

@media (min-width: 1600px) {
  .scaler {
    transform-origin: center center;
    transform: scale(0.87);
  }
}

/* 动画图片响应式样式 */
.anim-image {
  width: 1000px;
  height: 1414px;
  z-index: 1;
  position: absolute;
}

.anim-idle {
  margin-left: 1px;
  margin-top: -100px;
}

.anim-speaking {
  margin-left: 0px;
  margin-top: -101px;
}

/* 小屏幕适配：缩小图片尺寸，避免挡住倒计时 */
@media (max-width: 1600px) {
  .anim-idle {
    margin-left: -80px;
  }
  
  .anim-speaking {
    margin-left: -81px;
  }
}

/* 更小屏幕：进一步缩小 */
@media (max-width: 1200px) {
  .anim-idle {
    margin-left: -80px;
  }
  
  .anim-speaking {
    margin-left: -81px;
  }
}

/* .scaler {
  transform-origin: left top;
  transform: scale(0.67);
  允许鼠标事件穿透到Three.js场景
  pointer-events: none; 
} */

.image_1_ {
  width: 127px;
  height: 161px;
  margin: 178px 0 30px 300px;
}

.text_2_ {
  width: 800px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 22px;
  font-family: Afacad-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 22px 0 85px 0;
}

.not-allowed {
  width: 100%;
  height: 100%;
  background: linear-gradient(to top right, transparent 45%, rgba(177, 110, 249, 0.2) 45%, rgba(177, 110, 249, 1) 55%, transparent 55%);
  margin-top: -48px;
}

.spinner {
  border: 5px solid rgba(126, 180, 235, 1);
  border-radius: 50%;
  border-top: 5px solid rgba(177, 110, 249, 1);
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.audio-stream-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
}

.label_4 {
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.image-wrapper_4 {
  border-radius: 12px;
  background-color: rgba(177, 110, 249, 0.2);
  height: 48px;
  position: relative;
}

.audio-processor-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #f56c6c;
}

/* 自定义弹窗样式 */
.custom-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 400px;
  width: 90%;
}

.popup-image {
  width: 200px;
  height: auto;
  margin-bottom: 20px;
  border-radius: 10px;
}

.popup-text {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  font-family: Afacad-Regular;
}

 .btn {
   min-width: 88px;
   height: 36px;
   border-radius: 8px;
   border: none;
   cursor: pointer;
   font-size: 14px;
 }
 
 .btn-primary {
   background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
   color: #fff;
 }
 
 .btn-secondary {
   background: #f5f5f7;
   color: #666;
 }

.btn-outline {
  min-width: 120px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255,255,255,0.9);
  border: 1px solid rgba(177,110,249,0.6);
  color: #656587;
}

.btn-gradient {
  min-width: 120px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  color: #fff;
}

.ui-title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 6px;
  margin-bottom: 6px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ui-desc {
  color: #656587;
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
  max-width: 90%;
  margin: 6px auto 10px;
}

.ui-strong {
  font-weight: 700;
}

.ui-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 8px;
}

/* 噪音检测弹窗样式 */
.noise-detection-popup {
  max-width: 480px;
  width: 85%;
  padding: 0;
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.noise-detection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px 0 24px;
  margin-bottom: 12px;
}

.noise-title-spacer {
  width: 82px; /* 与图片宽度相同 */
  margin-right: 12px; /* 与图片和文字的间距相同 */
}

.noise-title {
  font-size: 18px;
  font-weight: 700;
  color: #656587;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #B16EF9;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #9B5DE5;
}

.noise-content {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0 24px 18px 24px;
}

.noise-image {
  flex-shrink: 0;
}

.check-image {
  width: 82px;
  height: auto;
  border-radius: 6px;
}

.noise-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.noise-message {
  color: #65658780  ;
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  text-align: left;
}

.noise-level-indicator {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.progress-bar-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* 字幕样式 */
.subtitle-container {
  position: static;
  margin: 16px 0 0 860px;
  width: 680px;
  min-height: 120px;
  overflow: visible;
  text-align: left;
}

.subtitle-content {
  background: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
  border-radius: 16px;
  padding: 12px 20px;
  box-shadow: 0 4px 16px rgba(126, 180, 235, 0.4), 
              0 2px 8px rgba(177, 110, 249, 0.3);
  display: inline-block;
  max-width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.subtitle-text {
  color: #ffffff;
  font-size: 20px;
  font-weight: 500;
  line-height: 2;
  word-wrap: break-word;
  overflow-wrap: break-word;
  letter-spacing: 0.3px;
  display: block;
}


.progress-bar {
  position: relative;
  height: 12px;
  background: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 62.5%, #FF8C42 75%, #ff6b6b 100%);
  border-radius: 6px;
  transition: width 0.3s ease;
}

.progress-marker {
  position: absolute;
  top: 0;
  width: 2px;
  height: 100%;
  background: #333;
  transform: translateX(-50%);
}

.progress-current {
  position: absolute;
  top: -2px;
  width: 16px;
  height: 16px;
  background: #FF8C42;
  border: 2px solid white;
  border-radius: 50%;
  transform: translateX(-50%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: left 0.3s ease-out;
}

.progress-labels {
  position: relative;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 5px;
}

.label-0 {
  color: #7EB4EB;
  font-weight: 500;
}

.label-50 {
  color: #B16EF9;
  font-weight: 500;
}

.label-80 {
  color: #ff6b6b;
  font-weight: 500;
}

.noise-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 5px;
}

.current-noise {
  color: #B16EF9;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.current-noise.noise-high {
  color: #ff6b6b;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.recommended-noise {
  color:  #656587;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.noise-actions {
  display: flex;
  gap: 9px;
  justify-content: center;
  margin-top: 11px;
}

.btn-outline {
  min-width: 90px;
  height: 36px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #656587;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
}

.btn-gradient {
  min-width: 90px;
  height: 36px;
  border-radius: 6px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  border: none;
  color: white;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 8px rgba(177, 110, 249, 0.2);
}

.btn-gradient:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(177, 110, 249, 0.4);
}

.btn:disabled {
  cursor: not-allowed;
  background: #BEBEBE  !important;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.btn:disabled:hover {
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .noise-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 12px 12px 12px;
  }
  
  .check-image {
    width: 68px;
  }
  
  .noise-detection-header {
    padding: 9px 12px 0 12px;
  }
  
  .noise-detection-popup {
    width: 90%;
    max-width: 400px;
  }
}
</style>

